import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import logo from '../assets/images/logo.png';
import '../styles/admin.css';
import {connect} from 'react-redux';
import {useCookies} from 'react-cookie';
import {logout, sync_login} from '../redux/actions/adminActions';
import Dashboard from '../components/admin/dashboard';
import Suppliers from '../components/admin/suppliers';
import Customers from '../components/admin/customers';
import Orders from '../components/admin/orders';
import Settings from '../components/admin/settings';
import Products from '../components/admin/products';
import Transactions from '../components/admin/transactions';
import CallRequest from '../components/admin/callRequest';
import Profile from '../components/admin/profile';

function Admin({logOut, isLoggedIn, syncLogin}) {
    const [cookies,
        setCookie,
        removeCookie] = useCookies(['token', 'currentAdmin']);
    const {token, currentAdmin} = cookies

    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn && !token) {
            handleLogout();
        }
    }, [isLoggedIn, token, navigate]);

    useEffect(() => {
        if (token) {
            syncLogin(token, currentAdmin)
        } else {
            handleLogout()
        }
    }, [isLoggedIn, navigate]);

    const [active,
        setActive] = useState(false);

    const [dropDownActive,
        setDropdown] = useState(false);

    const [index,
        setIndex] = useState(0);

    const handleLogout = () => {
        setCookie('token', null, {path: '/'});
        setCookie('currentAdmin', null, {path: '/'});
        logOut(navigate)    
    }

    const tabs = [
        {
            text: 'Dashboard'
        }, {
            text: 'Suppliers'
        }, {
            icon: 'ri-apps-2-line',
            text: 'Customers'
        }, {
            icon: 'ri-newspaper-line',
            text: 'Orders'
        }, {
            text: 'Products'
        }, {
            text: 'Transactions'
        }, {
            text: 'Call Request'
        }, {
            text: "Profile"
        }, {
            text: "Settings"
        }
    ]

    return (

        <div className="admin">

            <div className="rAlign container pt-3 mobileShow">
                <i
                    className={`${active
                    ? 'ri-arrow-left-s-line'
                    : 'ri-menu-2-line'} sectionText--big`}
                    onClick={() => setActive(!active)}></i>
            </div>

            <Tabs selectedIndex={index} onSelect={(index) => setIndex(index)}>
                <div className="">
                    <div className={`sideNav ${active && 'active'} pt-3`}>
                        <div className="center w-100">
                            <img src={logo} alt=""/>
                        </div>

                        <div className="pt-5">
                            <div className="">
                                <TabList className='p-0 '>
                                    {tabs.map(item => (
                                        <Tab className={`textIsBold--semi sectionText--mid isClickable mt-2 tabHead`}>
                                            {item.text}</Tab>
                                    ))}
                                </TabList>
                            </div>
                        </div>

                    </div>

                    <div className="tabContent px-5">
                        <div className="flexEnd alignOnly mobileBlock">

                            <div className="">
                                <div
                                    className="alignOnly sectionText isClickable pt-2"
                                    onClick={() => setDropdown(!dropDownActive)}>
                                    <i className="ri-user-line"></i>
                                    <span className="mx-2 textBold">Hi, {'  '}{currentAdmin
                                            ?.first_name}</span>
                                    <i class="ri-arrow-drop-down-line"></i>
                                </div>

                                {dropDownActive && <div className="dropdown__content">
                                    <div className="caret"></div>
                                    <div className="textIsBold vAlign sectionText--small">
                                        <div className="isClickable option" onClick={() => setIndex(7)}>
                                            Profile
                                        </div>
                                        <div className="isClickable option" onClick={handleLogout}>
                                            Logout
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>

                        <div className="  sectionHeight pt-5 mt-3">
                            <div className="w-100">
                                <TabPanel>
                                    <Dashboard/>
                                </TabPanel>
                                <TabPanel>
                                    <Suppliers/>
                                </TabPanel>
                                <TabPanel>
                                    <Customers/>
                                </TabPanel>
                                <TabPanel>
                                    <Orders/>
                                </TabPanel>
                                <TabPanel>
                                    <Products/>
                                </TabPanel>
                                <TabPanel>
                                    <Transactions/>
                                </TabPanel>
                                <TabPanel>
                                    <CallRequest/>
                                </TabPanel>
                                <TabPanel>
                                    <Profile/>
                                </TabPanel>
                                <TabPanel>
                                    <Settings/>
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                </div>
            </Tabs>

        </div>
    )
}

const mapStateToProps = (state) => ({isLoggedIn: state.admin.isLoggedIn, currentAdmin: state.admin.currentAdmin});

const mapDispatchToProps = (dispatch) => ({
    logOut: (navigator) => dispatch(logout(navigator)),
    syncLogin: (token, currentAdmin) => dispatch(sync_login(token, currentAdmin))
})

export default connect(mapStateToProps, mapDispatchToProps)(Admin)
